<template>
  <v-row dense align="center" class="horario-periodo-filtro">
    <v-col cols="12" sm="7" md="6" lg="5">
      <v-btn
        class="horario-periodo-filtro__date-btn"
        color="primary"
        outlined
        :disabled="disabled"
        @click="dialogPeriodo = true"
      >
        <v-icon left small>mdi-calendar-range</v-icon>
        {{ periodoLabel }}
      </v-btn>

      <div v-if="dataFimErrors.length" class="error--text text-caption mt-1">
        {{ dataFimErrors[0] }}
      </div>
    </v-col>

    <v-col cols="12" class="d-flex flex-wrap align-center">
      <v-btn color="primary" :disabled="botaoDesabilitado" :loading="loading" @click="buscar">
        <v-icon left small>mdi-magnify</v-icon>
        Buscar
      </v-btn>

      <v-btn
        color="red darken-1"
        class="ml-2"
        dark
        :disabled="botaoDesabilitado"
        :loading="loadingPdf"
        @click="gerarPdf"
      >
        <v-icon left small>mdi-file-pdf</v-icon>
        PDF
      </v-btn>
    </v-col>

    <v-dialog v-model="dialogPeriodo" max-width="450">
      <v-card>
        <v-card-title class="text-h5">Selecionar período</v-card-title>

        <v-card-text>
          <v-row justify="center" class="mt-4">
            <v-date-picker
              v-model="periodoSelecionado"
              locale="pt-br"
              :show-current="false"
              range
            ></v-date-picker>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="dialogPeriodo = false">Cancelar</v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="!periodoSelecionado.length"
            @click="aplicarPeriodo"
          >
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: "HorarioPeriodoFiltro",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingPdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const periodoInicial = [...(this.value || [])].sort();
    const dataInicio = periodoInicial[0] || null;
    const dataFim = periodoInicial[1] || dataInicio;

    return {
      dialogPeriodo: false,
      periodoSelecionado: periodoInicial,
      form: {
        data_inicio: dataInicio,
        data_fim: dataFim,
      },
    };
  },
  computed: {
    datasPreenchidas() {
      return Boolean(this.form.data_inicio && this.form.data_fim);
    },
    periodoValido() {
      if (!this.datasPreenchidas) return false;
      return this.form.data_fim >= this.form.data_inicio;
    },
    dataFimErrors() {
      if (!this.datasPreenchidas || this.periodoValido) return [];
      return ["Data final não pode ser menor que a data inicial."];
    },
    botaoDesabilitado() {
      return this.disabled || !this.periodoValido;
    },
    periodoLabel() {
      if (!this.datasPreenchidas) return "Selecionar período";
      return `${this.formatarData(this.form.data_inicio)} a ${this.formatarData(
        this.form.data_fim
      )}`;
    },
  },
  watch: {
    value(value) {
      const periodo = [...(value || [])].sort();
      const dataInicio = periodo[0] || null;
      const dataFim = periodo[1] || dataInicio;

      this.periodoSelecionado = periodo;
      this.form = {
        data_inicio: dataInicio,
        data_fim: dataFim,
      };
    },
  },
  methods: {
    aplicarPeriodo() {
      const [dataInicio, dataFim = dataInicio] = [...this.periodoSelecionado].sort();

      this.form.data_inicio = dataInicio;
      this.form.data_fim = dataFim;
      this.dialogPeriodo = false;
      this.$emit("input", [dataInicio, dataFim].filter(Boolean));
    },
    buscar() {
      if (this.botaoDesabilitado) return;
      this.$emit("buscar", { ...this.form });
    },
    gerarPdf() {
      if (this.botaoDesabilitado) return;
      this.$emit("gerar-pdf", { ...this.form });
    },
    formatarData(data) {
      if (!data) return "";
      const [ano, mes, dia] = data.split("-");
      return `${dia}/${mes}/${ano}`;
    },
  },
};
</script>

<style scoped>
.horario-periodo-filtro__date-btn {
  min-width: 250px;
  justify-content: flex-start;
}
</style>
